export const strings = {
  en: {
    beamAttribution: () => `Powered by Beam`,
    ctaTitle: () => `Choose your impact`,
    ctaPromoPrefixMessage: () => `At no extra cost,`,
    ctaPromoMessage: ({ donationPercentage = "1" } = {}) =>
      `At no extra cost, select a nonprofit and ${donationPercentage}% will be donated there for you.`,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `At no extra cost, select a nonprofit and ${donationPercentage}% will be donated there for you.`,
    submitButtonText: () => `Confirm`,
    submitButtonTextCompleted: () => `Confirmed!`,
    chooseButtonText: () => `Choose a nonprofit`,
  },
  fr: {
    beamAttribution: () => `Optimisé par Beam`,
    ctaTitle: () => `Choisissez votre cause`,
    ctaPromoPrefixMessage: () => ``, // TODO: Update translation copy SDK-2210
    ctaPromoMessage: () => ``, // TODO: Update translation copy SDK-2210
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Choisissez un organisme à but non lucratif et ${donationPercentage} % lui sera versé en votre nom, sans frais supplémentaires.`, // TODO: Update translation copy SDK-2210
    submitButtonText: () => `Confirmer`, // TODO: Update translation copy SDK-2210
    submitButtonTextCompleted: () => `Confirmé!`,
    chooseButtonText: () => `Choisissez`, // TODO: Update translation copy SDK-2210
  },
  de: {
    beamAttribution: () => `Unterstützt von Beam`,
    ctaTitle: () => `Wähle deinen Impact`,
    ctaPromoPrefixMessage: () => ``, // TODO: Update translation copy SDK-2210
    ctaPromoMessage: () => ``, // TODO: Update translation copy SDK-2210
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Wähle eine der gemeinnützigen Organisationen und spende ${donationPercentage}% deines Einkaufs ohne zusätzliche Kosten`, // TODO: Update translation copy SDK-2210
    submitButtonText: () => "Bestätigen", // TODO: Update translation copy SDK-2210
    submitButtonTextCompleted: () => `Bestätigt!`,
    chooseButtonText: () => `Wählen`, // TODO: Update translation copy SDK-2210
  },
  es: {
    ctaTitle: () => "Elige tu contribución",
    ctaPromoPrefixMessage: () => ``, // TODO: Update translation copy SDK-2210
    ctaPromoMessage: () => ``, // TODO: Update translation copy SDK-2210
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Elige una organización sin fines de lucro y donaremos ${donationPercentage}% de tu compra sin coste adicional.`, // TODO: Update translation copy SDK-2210
    beamAttribution: () => "Ofrecido por Beam",
    submitButtonText: () => "Confirmar", // TODO: Update translation copy SDK-2210
    submitButtonTextCompleted: () => "¡Confirmado!",
    chooseButtonText: () => `Elige`, // TODO: Update translation copy SDK-2210
  },
  it: {
    ctaTitle: () => "Scegli dove fare la differenza",
    ctaPromoPrefixMessage: () => ``, // TODO: Update translation copy SDK-2210
    ctaPromoMessage: () => ``, // TODO: Update translation copy SDK-2210
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Seleziona un'organizzazione no-profit a cui devolvere l’${donationPercentage}% del tuo acquisto, senza costi aggiuntivi`, // TODO: Update translation copy SDK-2210
    beamAttribution: () => "Gestito da Beam",
    submitButtonText: () => "Confermare", // TODO: Update translation copy SDK-2210
    submitButtonTextCompleted: () => "Confermato!",
    chooseButtonText: () => `Scegli`, // TODO: Update translation copy SDK-2210
  },
  pl: {
    beamAttribution: () => `Wspierany przez Beam`,
    ctaTitle: () => `Wybierz inicjatywę, którą chcesz wesprzeć`,
    ctaPromoPrefixMessage: () => ``, // TODO: Update translation copy SDK-2210
    ctaPromoMessage: () => ``, // TODO: Update translation copy SDK-2210
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Wybierz organizację, której przekażesz ${donationPercentage}% wartości Twoich zakupów – bez żadnych dodatkowych kosztów!`, // TODO: Update translation copy SDK-2210
    submitButtonText: () => `Zatwierdź`, // TODO: Update translation copy SDK-2210
    submitButtonTextCompleted: () => `Zatwierdzono!`,
    chooseButtonText: () => `Wybierz`, // TODO: Update translation copy SDK-2210
  },
};
